/* CUSTOM form-figure — technischer SCHNITT der Keramik-Form auf der Produktseite.
 * Liest das fertige Schnitt-Polygon aus dem Metaobjekt form_spec (Data-Attribute vom Snippet).
 * profile-JSON (Studiolog): {"p":[[r,y],…], "fh":randvoll-Höhe, "fr":Innenradius@fh,
 *                            "sh":serviermengen-Höhe, "sr":Innenradius@sh}
 *   - p = EIN fertiges geschlossenes Polygon (Rundungen/Trinkrand/Boden-Fillet + Spiegelung schon drin).
 *     Zeichnen: M p[0], L durch alle, Z. Ton-in-Ton gefüllt, ein Stroke (~1,6px), linejoin round.
 *   - Füll-Linien: randvoll gestrichelt bei fh (Breite ±fr), Serviermenge bei sh (±sr).
 *   - Öffnung/Höhe/Breite als Maßketten. Schrift & Linien konstant (1:1-SVG), nur das Objekt skaliert.
 * Datenpflege des Metaobjekts (inkl. Polygon) = Studiolog. Nichts rekonstruieren — nur zeichnen.
 */
(function () {
  if (customElements.get('form-figure')) return;

  var CX = 150;         // Objekt-Mitte (Arbeitswert; viewBox wird später verschoben)
  var DRAW_HALF_W = 66; // maximale Objekt-Halbbreite (px)
  var DRAW_H = 104;     // maximale Objekt-Höhe (px)
  var LINE_EXT = 26;    // Überstand der Füllstand-Linien nach rechts (zum Label)
  var WAVE_L = 150;     // Wellenlänge (muss zur CSS-Keyframe-Verschiebung passen)
  var uid = 0;

  // Schnittpunkte des Polygons mit der Horizontalen y (cm) → sortierte x-Radien.
  function crossingsAtY(pts, y) {
    var xs = [];
    for (var i = 0; i < pts.length; i++) {
      var a = pts[i], b = pts[(i + 1) % pts.length];
      if ((a[1] <= y && b[1] > y) || (b[1] <= y && a[1] > y)) {
        xs.push(a[0] + (y - a[1]) / (b[1] - a[1]) * (b[0] - a[0]));
      }
    }
    xs.sort(function (m, n) { return m - n; });
    return xs;
  }
  // Cavity (Innenraum) aus dem Wand-Polygon rekonstruieren: je Höhe der innerste positive
  // Schnittpunkt = Innenwand-Radius; gespiegelt ergibt das den Hohlraum bis knapp unter den Rand.
  function buildCavity(pts, yMaxCm, X, Y, f2) {
    var right = [], steps = 64, gotTop = null;
    for (var s = 1; s <= steps; s++) {
      var ycm = yMaxCm * s / steps;
      var xs = crossingsAtY(pts, ycm);
      var pos = xs.filter(function (v) { return v > 0.02; });
      if (pos.length >= 2) { right.push([pos[0], ycm]); gotTop = ycm; }
      else if (right.length) break; // oben verschmelzen Innen-/Außenwand (Rand) → Cavity zu Ende
    }
    if (right.length < 2) return null;
    var d = 'M' + f2(X(right[0][0])) + ' ' + f2(Y(right[0][1]));
    for (var i = 1; i < right.length; i++) d += ' L' + f2(X(right[i][0])) + ' ' + f2(Y(right[i][1]));
    for (var j = right.length - 1; j >= 0; j--) d += ' L' + f2(X(-right[j][0])) + ' ' + f2(Y(right[j][1]));
    d += ' Z';
    return { d: d, topCm: gotTop };
  }

  function num(str) {
    if (str == null) return NaN;
    var m = String(str).replace(',', '.').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }
  function comma(str) { return String(str == null ? '' : str).replace('.', ','); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  class FormFigure extends HTMLElement {
    connectedCallback() {
      if (this._done) return;
      this._done = true;

      var profile;
      try { profile = JSON.parse(this.getAttribute('data-profile') || ''); } catch (e) { profile = null; }
      if (!profile || !profile.p || !profile.p.length) { this.style.display = 'none'; return; }

      var p = profile.p.map(function (pt) { return [Number(pt[0]), Number(pt[1])]; });
      var fh = Number(profile.fh) || 0, fr = Number(profile.fr) || 0;
      var sh = Number(profile.sh) || 0, sr = Number(profile.sr) || 0;

      var widthStr    = this.getAttribute('data-width')    || '';
      var heightStr   = this.getAttribute('data-height')   || '';
      var openingStr  = this.getAttribute('data-opening')  || '';
      var capacityStr = this.getAttribute('data-capacity') || '';
      var servingStr  = this.getAttribute('data-serving')  || '';

      var maxR = 0, maxH = 0;
      p.forEach(function (pt) { var a = Math.abs(pt[0]); if (a > maxR) maxR = a; if (pt[1] > maxH) maxH = pt[1]; });
      if (maxR <= 0 || maxH <= 0) { this.style.display = 'none'; return; }

      // FESTER Maßstab (px pro cm) für ALLE Objekte → reale Größenverhältnisse (Espresso klein,
      // Bowl groß). KEIN Hochskalieren kleiner Objekte mehr. Die Box-Grenzen wirken nur noch als
      // Obergrenze, damit sehr große Objekte nicht überlaufen. Schrift ist px-fix (CSS) → immer gleich.
      var PX_PER_CM = 8;
      var S = Math.min(PX_PER_CM, DRAW_HALF_W / maxR, DRAW_H / maxH);
      var objH = maxH * S;
      var topPad = openingStr ? 34 : 14;
      var botPad = 38;
      var BASE_Y = topPad + objH;
      var canvasH = topPad + objH + botPad;
      var X = function (r) { return CX + r * S; };
      var Y = function (cm) { return BASE_Y - cm * S; };
      var f2 = function (v) { return (Math.round(v * 100) / 100).toFixed(2); };
      var yTop = Y(maxH);

      var parts = [];
      var maxContentX = X(maxR), minContentX = X(-maxR), minY = 0;
      function extentR(x) { if (x > maxContentX) maxContentX = x; }
      function extentL(x) { if (x < minContentX) minContentX = x; }
      function extentT(y) { if (y < minY) minY = y; }
      function estWidth(txt) { return txt.length * 6.6; } // ~10px GT Pressura Mono (= Micro/Caption)


      var fid = 'ff' + (++uid);   // figur-weite ID (Cavity-Clip)
      var yServe = sh > 0 ? Y(sh) : 0;
      var hasServe = servingStr && sh > 0 && sr > 0;
      var hasFull = capacityStr && fh > 0 && fr > 0;

      // --- Mittelachse (Strichpunkt), dezent hinter allem ---
      parts.push('<line class="form-figure__axis" x1="' + CX + '" y1="' + f2(yTop - 8) + '" x2="' + CX + '" y2="' + f2(BASE_Y + 6) + '" stroke-width="0.7"/>');

      // --- Flüssigkeit (Serviermenge) im HOHLRAUM: Cavity aus dem Polygon rekonstruiert, Wasser
      //     bis sh, lebendige Dünung (geclippt). Wird VOR der Wand gezeichnet → Wand-Stroke bleibt scharf. ---
      var cavity = (sh > 0) ? buildCavity(p, maxH, X, Y, f2) : null;
      if (cavity && hasServe) {
        var id = fid;
        var botY = BASE_Y + 10, amp = 2.3;
        var fill = 'M' + (-WAVE_L) + ' ' + f2(yServe), crest = '';
        for (var wx = -WAVE_L; wx <= maxContentX + WAVE_L; wx += WAVE_L / 24) {
          var wy2 = yServe + amp * Math.sin((wx / WAVE_L) * 2 * Math.PI);
          fill += ' L' + f2(wx) + ' ' + f2(wy2);
          crest += (crest ? ' L' : 'M') + f2(wx) + ' ' + f2(wy2);
        }
        fill += ' L' + f2(maxContentX + WAVE_L) + ' ' + botY + ' L' + (-WAVE_L) + ' ' + botY + ' Z';
        parts.push('<clipPath id="' + id + '-cav"><path d="' + cavity.d + '"/></clipPath>');
        parts.push('<g clip-path="url(#' + id + '-cav)"><g class="form-figure__liquid">' +
          '<path class="form-figure__wave" d="' + fill + '"/>' +
          '<path class="form-figure__wave-surface" d="' + crest + '" fill="none" stroke-width="1"/>' +
          '</g></g>');
      }

      // --- Schnitt-Polygon (Studiolog, fertig): geschnittenes Material als ruhige Fläche (keine
      //     Konturlinie, keine Schraffur), Farbton abgesetzt vom Wasser-Grau — ÜBER dem Wasser ---
      var d = 'M' + f2(X(p[0][0])) + ' ' + f2(Y(p[0][1]));
      for (var i = 1; i < p.length; i++) d += ' L' + f2(X(p[i][0])) + ' ' + f2(Y(p[i][1]));
      d += ' Z';
      parts.push('<path class="form-figure__wall" d="' + d + '"/>');

      // --- Füllstand-Linien randvoll (bei fh) + Serviermenge (bei sh) als volle gestrichelte Linien.
      //     Labels immer rechts, linksbündig auf gemeinsamer Spalte (auch bei breiten Bowls).
      //     Nur der ml-Wert — WAS gemeint ist (randvoll oben, Serviermenge tiefer) zeigt die
      //     animierte Wasserfüllung + die Höhe der Linie selbst. ---
      var yFull = hasFull ? Y(fh) : 0;
      var slabel = '~' + servingStr;
      var flabel = '~' + capacityStr;

      var innerMax = Math.max(hasFull ? fr : 0, hasServe ? sr : 0);
      // Labels vertikal ZENTRIERT auf ihrer Linie (dominant-baseline central, y = Linien-y).
      // Nur wenn beide Linien zu nah beieinander liegen, das Serviermenge-Label leicht nach unten schieben.
      var lineRight = X(innerMax) + LINE_EXT, labelX = lineRight + 5;
      var fLabY = yFull, sLabY = yServe;
      if (hasFull && hasServe && (sLabY - fLabY) < 12) sLabY = fLabY + 12;
      if (hasServe) {
        parts.push('<line class="form-figure__serve-line" x1="' + f2(X(-sr)) + '" y1="' + f2(yServe) + '" x2="' + f2(lineRight) + '" y2="' + f2(yServe) + '" stroke-width="0.9" stroke-dasharray="3 2"/>');
        parts.push('<text class="form-figure__serve-label" x="' + f2(labelX) + '" y="' + f2(sLabY) + '" dominant-baseline="central">' + esc(slabel) + '</text>');
        extentR(labelX + estWidth(slabel));
      }
      if (hasFull) {
        parts.push('<line class="form-figure__full-line" x1="' + f2(X(-fr)) + '" y1="' + f2(yFull) + '" x2="' + f2(lineRight) + '" y2="' + f2(yFull) + '" stroke-width="0.9" stroke-dasharray="3 2"/>');
        parts.push('<text class="form-figure__full-label" x="' + f2(labelX) + '" y="' + f2(fLabY) + '" dominant-baseline="central">' + esc(flabel) + '</text>');
        extentR(labelX + estWidth(flabel));
      }

      // ---- Maßketten (DIN-Stil): Maßhilfslinien + 45°-Begrenzung, Maßzahl IN der aufgebrochenen Maßlinie ----
      function tick(x, y) { return '<line class="form-figure__dim" x1="' + f2(x - 2) + '" y1="' + f2(y + 2) + '" x2="' + f2(x + 2) + '" y2="' + f2(y - 2) + '" stroke-width="0.7"/>'; }
      function dline(x1, y1, x2, y2) { return '<line class="form-figure__dim" x1="' + f2(x1) + '" y1="' + f2(y1) + '" x2="' + f2(x2) + '" y2="' + f2(y2) + '" stroke-width="0.7"/>'; }
      // Maßzahl mittig in der Maßlinie (Lücke); wenn die Linie dafür zu kurz ist → Zahl daneben.
      function hLabel(x1, x2, y, label) {
        var lw = estWidth(label), cx = (x1 + x2) / 2, out = tick(x1, y) + tick(x2, y);
        if (x2 - x1 > lw + 10) {
          out += dline(x1, y, cx - lw / 2 - 3, y) + dline(cx + lw / 2 + 3, y, x2, y);
          out += '<text class="form-figure__dim-label" x="' + f2(cx) + '" y="' + f2(y) + '" text-anchor="middle" dominant-baseline="central">' + label + '</text>';
        } else {
          out += dline(x1, y, x2, y) + '<text class="form-figure__dim-label" x="' + f2(cx) + '" y="' + f2(y - 3) + '" text-anchor="middle">' + label + '</text>';
        }
        return out;
      }
      function vLabel(x, yBot, yTop2, label) {
        var lw = estWidth(label), my = (yBot + yTop2) / 2, out = tick(x, yBot) + tick(x, yTop2);
        if (yBot - yTop2 > lw + 10) {
          out += dline(x, yBot, x, my + lw / 2 + 3) + dline(x, my - lw / 2 - 3, x, yTop2);
          out += '<text class="form-figure__dim-label" transform="rotate(-90 ' + f2(x) + ' ' + f2(my) + ')" x="' + f2(x) + '" y="' + f2(my) + '" text-anchor="middle" dominant-baseline="central">' + label + '</text>';
        } else {
          out += dline(x, yBot, x, yTop2);
          out += '<text class="form-figure__dim-label" transform="rotate(-90 ' + f2(x - 3) + ' ' + f2(my) + ')" x="' + f2(x - 3) + '" y="' + f2(my) + '" text-anchor="middle">' + label + '</text>';
          extentT(my - lw / 2 - 2);
        }
        return out;
      }

      // Maßhilfslinien nur als kurze Stummel an der Maßlinie (nicht bis zum Objekt) → mehr Weiß dazwischen.
      // Öffnung — Maßkette OBEN
      var rOpen = num(openingStr) / 2;
      if (openingStr && !isNaN(rOpen) && rOpen > 0) {
        var oy = yTop - 24, ox1 = X(-rOpen), ox2 = X(rOpen);
        parts.push(dline(ox1, oy + 4, ox1, oy - 4) + dline(ox2, oy + 4, ox2, oy - 4));
        parts.push(hLabel(ox1, ox2, oy, '⌀ ~' + esc(comma(openingStr))));
        extentT(oy - 8);
      }

      // Höhe — Maßkette LINKS
      var dimX = X(-maxR) - 28;
      extentL(dimX - 10);
      parts.push(dline(dimX + 4, BASE_Y, dimX - 4, BASE_Y) + dline(dimX + 4, yTop, dimX - 4, yTop));
      if (heightStr) parts.push(vLabel(dimX, BASE_Y, yTop, '~' + esc(comma(heightStr))));
      else parts.push(dline(dimX, BASE_Y, dimX, yTop) + tick(dimX, BASE_Y) + tick(dimX, yTop));

      // Breite / Ø — Maßkette UNTEN
      if (widthStr) {
        var wy = BASE_Y + 32;
        parts.push(dline(X(-maxR), wy - 4, X(-maxR), wy + 4) + dline(X(maxR), wy - 4, X(maxR), wy + 4));
        parts.push(hLabel(X(-maxR), X(maxR), wy, '⌀ ~' + esc(comma(widthStr))));
      }

      // --- Boden / Stellfläche: durchgehende Grundlinie bis unter die Füllstand-Labels rechts.
      //     Am Ende berechnet (maxContentX final) und nach ganz hinten gelegt (unter Objekt/Wasser). ---
      var gLeft = minContentX, gRight = maxContentX;
      var groundSvg = '<line class="form-figure__ground" x1="' + f2(gLeft) + '" y1="' + BASE_Y + '" x2="' + f2(gRight) + '" y2="' + BASE_Y + '" stroke-width="1"/>';
      var gh = '';
      for (var ghx = gLeft + 5; ghx <= gRight + 0.5; ghx += 6) gh += 'M' + f2(ghx) + ' ' + BASE_Y + ' l-5 5 ';
      groundSvg += '<path class="form-figure__ground-hatch" d="' + gh + '" stroke-width="0.7" fill="none"/>';
      parts.unshift(groundSvg);

      var pad = 6;
      var vbMin = Math.floor(minContentX - pad);
      var vbW = Math.ceil(maxContentX + pad) - vbMin;
      var vbTop = Math.floor(Math.min(0, minY) - 2);
      var vbH = Math.ceil(canvasH - vbTop);
      var aria = 'Technischer Schnitt' + (widthStr ? ', Ø ' + widthStr : '') + (heightStr ? ', Höhe ' + heightStr : '') +
        (openingStr ? ', Öffnung ' + openingStr : '') + (servingStr ? ', Serviermenge ' + servingStr : '') + (capacityStr ? ', randvoll ' + capacityStr : '');
      this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vbMin + ' ' + vbTop + ' ' + vbW + ' ' + vbH + '" width="' + vbW + '" height="' + vbH + '" role="img" aria-label="' + esc(aria) + '">' + parts.join('') + '</svg>';
    }
  }

  customElements.define('form-figure', FormFigure);
})();
